import { render, staticRenderFns } from "./AdminSection.vue?vue&type=template&id=1a5cb8b4&scoped=true&"
import script from "./AdminSection.vue?vue&type=script&lang=js&"
export * from "./AdminSection.vue?vue&type=script&lang=js&"
import style0 from "./AdminSection.vue?vue&type=style&index=0&id=1a5cb8b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a5cb8b4",
  null
  
)

export default component.exports